import { Group, MantineSpacing, Paper, PaperProps } from '@mantine/core';
import { ReactNode } from 'react';
import { ClickableSectionTitle } from 'src/UI/page-nav/ClickableSectionTitle';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  title: string;
  actions?: ReactNode;
  children: ReactNode;
  titleMb?: MantineSpacing;
  titleFontWeight?: number;
  paperProps?: Omit<PaperProps, 'children' | 'variant'>;
};

export function ProfileSectionLayout({
  title,
  actions,
  children,
  titleMb = 'md',
  titleFontWeight = FONT_WEIGHTS.semibold,
  paperProps,
}: Props) {
  return (
    <Paper variant="content" mb="md" {...paperProps}>
      <Group justify="space-between" mb={titleMb} align="center">
        <ClickableSectionTitle fw={titleFontWeight} size="lg" data-testid="section-label">
          {title}
        </ClickableSectionTitle>
        {actions}
      </Group>
      {children}
    </Paper>
  );
}
